import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import PageDescription from 'components/PageDescription';

const TOPICS = [
  {
    title: 'O que são cookies e trackers?',
    paragraphs: [
      'Trackers são ferramentas de observação na internet e cookies são o mais famoso tipo de tracker. Quando você acessa sites, eles podem enviar pequenos arquivos de texto (cookies) para o seu navegador para registrar o seu comportamento. É por causa de cookies, por exemplo, que você vê anúncios de coisas que você já procurou quando visita sites de mídias sociais, notícias e mais.',
    ],
  },
  {
    title: 'Informações que nossos parceiros coletam',
    paragraphs: [
      'Usamos alguns parceiros para incrementar nossa experiência geral de navegação na web. Eles usam cookies e outros mecanismos para conectá-lo às suas redes sociais e adequar a publicidade para melhor satisfazer os seus interesses.',
    ],
  },
  {
    title: 'Onde minhas preferências ficam salvas?',
    paragraphs: [
      'Se você configurou as preferências sem logar em nossa plataforma, elas ficam salvas no seu navegador quando utilizado o web, ou caso esteja utilizando o aplicativo, ficam salvos no aplicativo. Nesse caso, no momento que você fizer o login em nossa plataforma, a última configuração salva no seu dispositivo será vinculada a sua conta do Promobit.',
      'Dessa forma, as suas preferências sempre estarão sincronizadas entre as diversas formas de acessar nossa plataforma.',
    ],
  },
];

const CookiesPageDescription = ({ className }) => (
  <PageDescription
    className={twMerge('bg-transparent dark:bg-transparent', className)}
    pageDescription={TOPICS}
  />
);

CookiesPageDescription.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default CookiesPageDescription;
